import { render, staticRenderFns } from "./tataleContrat.vue?vue&type=template&id=178f2f41"
import script from "./tataleContrat.vue?vue&type=script&lang=js"
export * from "./tataleContrat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports